import { 
    css, 
  } from "@bdfx/fukit"

// export const clip = "polygon(0 8%, 7% 6%, 14% 5%, 21% 5%, 28% 6%, 34% 8%, 40% 12%, 46% 17%, 50% 20%, 54% 23%, 60% 25%, 66% 26%, 70% 26%, 77% 25%, 83% 23%, 89% 21%, 95% 19%, 100% 17%, 100% 100%, 0% 100%)"
// export const shadow = "drop-shadow(0px 8px 4px rgba(0,0,0,0.2))"


const Section = css("div")({
    // filter: shadow,
    position: "relative",
    textAlign: "left",
    "> div": {
      // clipPath: clip,
      background: "#fff",
      "> div": {
        maxWidth: "1200px",
        margin: "auto",
        },
    },
  
  })

  export default Section